import React from "react";

import Link from "next/link";

import { ADDRESS_SVG } from "../../../../../constants/svgClubConstants";
import { useRouter } from "next/router";
import Image from "next/image";
import clsx from "clsx";

function DesctopCardBlock({
  activeMediaSize,
  id,
  activeHallId,
  title,
  setActiveHallId,
  image,
  address,
  scheduleButton,
  imageTitleEnabled,
  scheduleDefaultView,
}) {
  const router = useRouter();
  const {
    query: { club },
  } = router;

  return (
    <div
      className={
        activeMediaSize
          ? `club-hall-wrapper card-media-size-${activeMediaSize.count}`
          : "club-hall-wrapper"
      }
    >
      <div
        onClick={() => setActiveHallId(+id)}
        className={clsx("club-hall", {
          "club-hall_active": id == activeHallId,
          "club-hall--blackout-off": !imageTitleEnabled,
        })}
      >
        {image && (
          <Image
            className="club-hall__img"
            src={image}
            fill
            sizes="(min-width: 768px) 50vw, 100vw"
            alt="club-img"
          />
        )}
        <div className="club-hall-inner">
          <div className={clsx("club-hall-content")}>
            {imageTitleEnabled && (
              <>
                <h3 className="club-hall-name">{title}</h3>
                {/* {imageTitleEnabled ? title : "\u00A0"} */}
                <div className="club-hall-address-block">
                  {address ? (
                    <>
                      {ADDRESS_SVG}
                      <p className="club-hall-address">{address}</p>
                    </>
                  ) : (
                    <br />
                  )}
                </div>
                <Link
                  href={{
                    pathname: `/club/${club}/schedule/${scheduleDefaultView}/${+id}`,
                  }}
                  className="club-hall-button"
                >
                  {scheduleButton}
                </Link>
              </>
            )}
          </div>
        </div>
      </div>

      <button className="club-hall-button mobile-only">{scheduleButton}</button>
    </div>
  );
}

export default DesctopCardBlock;
